module.exports = __webpack_public_path__ + "img/title_pc.1ace048c.svg";